import type {IFormDataV2} from 'src/types/FormV2';

/**
 * Converts a typed API entity into form data. Typed response models have no
 * index signature, so this is the single sanctioned conversion point —
 * consumers should never cast entities to IFormDataV2 themselves.
 */
export function toFormDataV2<T extends object>(
  entity: T | null | undefined
): IFormDataV2 {
  return {...entity};
}
